module.exports = __webpack_public_path__ + "img/wx.15b089ac.png";